/*
* Story Theme Custom JS - Mobile Price Fix
* Syncs variant prices from desktop to mobile when variant selection changes
* Uses continuous polling to ensure prices stay in sync even after Section API updates
*/

(function() {
  var pollingInterval = null;
  var pollingTimeout = null;
  var isPolling = false;
  
  function syncPrices() {
    // 1. Find the desktop price block (source of truth)
    var desktopPriceBlock = document.querySelector('.product__price-block--desktop [data-product-price]') ||
                            document.querySelector('[data-form-wrapper] [data-product-price]') ||
                            document.querySelector('.product__form__wrapper [data-product-price]');
    
    var desktopComparePrice = document.querySelector('.product__price-block--desktop [data-compare-price]') ||
                              document.querySelector('[data-form-wrapper] [data-compare-price]') ||
                              document.querySelector('.product__form__wrapper [data-compare-price]');
    
    var desktopPriceOff = document.querySelector('.product__price-block--desktop [data-price-off]') ||
                          document.querySelector('[data-form-wrapper] [data-price-off]') ||
                          document.querySelector('.product__form__wrapper [data-price-off]');
    
    // 2. Find the mobile price block (target to update)
    var mobilePriceBlock = document.querySelector('.product__price-block--mobile [data-product-price]') ||
                           document.querySelector('.medium-up--hide [data-product-price]');
    
    var mobileComparePrice = document.querySelector('.product__price-block--mobile [data-compare-price]') ||
                             document.querySelector('.medium-up--hide [data-compare-price]');
    
    var mobilePriceOff = document.querySelector('.product__price-block--mobile [data-price-off]') ||
                          document.querySelector('.medium-up--hide [data-price-off]');
    
    var pricesMatch = true;
    
    // 3. Sync main price
    if (desktopPriceBlock && mobilePriceBlock) {
      var desktopPriceText = desktopPriceBlock.innerHTML.trim();
      var mobilePriceText = mobilePriceBlock.innerHTML.trim();
      
      if (desktopPriceText !== mobilePriceText) {
        mobilePriceBlock.innerHTML = desktopPriceText;
        pricesMatch = false;
        console.log("Price Sync: Updated mobile price from", mobilePriceText, "to", desktopPriceText);
      }
    }
    
    // 4. Sync compare price
    if (desktopComparePrice && mobileComparePrice) {
      var desktopCompareText = desktopComparePrice.innerHTML.trim();
      var mobileCompareText = mobileComparePrice.innerHTML.trim();
      
      var desktopCompareVisible = desktopComparePrice.offsetParent !== null && 
                                   window.getComputedStyle(desktopComparePrice).display !== 'none';
      var mobileCompareVisible = mobileComparePrice.offsetParent !== null && 
                                  window.getComputedStyle(mobileComparePrice).display !== 'none';
      
      if (desktopCompareText !== mobileCompareText) {
        mobileComparePrice.innerHTML = desktopCompareText;
        pricesMatch = false;
        console.log("Price Sync: Updated mobile compare price");
      }
      
      // Sync visibility
      if (desktopCompareVisible !== mobileCompareVisible) {
        mobileComparePrice.style.display = desktopCompareVisible ? '' : 'none';
        pricesMatch = false;
      }
    } else if (mobileComparePrice) {
      // If desktop doesn't have compare price, hide mobile compare price
      var mobileCompareVisible = mobileComparePrice.offsetParent !== null && 
                                  window.getComputedStyle(mobileComparePrice).display !== 'none';
      if (mobileCompareVisible) {
        mobileComparePrice.style.display = 'none';
        pricesMatch = false;
      }
    }
    
    // 5. Sync price-off badge (sale badge)
    if (desktopPriceOff && mobilePriceOff) {
      var desktopBadgeText = desktopPriceOff.innerHTML.trim();
      var mobileBadgeText = mobilePriceOff.innerHTML.trim();
      
      var desktopBadgeVisible = desktopPriceOff.offsetParent !== null && 
                                 window.getComputedStyle(desktopPriceOff).display !== 'none';
      var mobileBadgeVisible = mobilePriceOff.offsetParent !== null && 
                                window.getComputedStyle(mobilePriceOff).display !== 'none';
      
      if (desktopBadgeText !== mobileBadgeText) {
        mobilePriceOff.innerHTML = desktopBadgeText;
        pricesMatch = false;
        console.log("Price Sync: Updated mobile price badge");
      }
      
      // Sync visibility
      if (desktopBadgeVisible !== mobileBadgeVisible) {
        mobilePriceOff.style.display = desktopBadgeVisible ? '' : 'none';
        pricesMatch = false;
      }
    } else if (mobilePriceOff) {
      // If desktop doesn't have badge, hide mobile badge
      var mobileBadgeVisible = mobilePriceOff.offsetParent !== null && 
                                window.getComputedStyle(mobilePriceOff).display !== 'none';
      if (mobileBadgeVisible) {
        mobilePriceOff.style.display = 'none';
        pricesMatch = false;
      }
    }
    
    return pricesMatch;
  }
  
  // Start continuous polling until prices match
  function startPolling() {
    if (isPolling) return; // Already polling
    
    isPolling = true;
    var attempts = 0;
    var maxAttempts = 50; // Poll for up to 10 seconds (50 * 200ms)
    
    console.log('Price Sync: Starting continuous polling');
    
    // Clear any existing polling
    if (pollingInterval) {
      clearInterval(pollingInterval);
    }
    if (pollingTimeout) {
      clearTimeout(pollingTimeout);
    }
    
    pollingInterval = setInterval(function() {
      attempts++;
      var pricesMatch = syncPrices();
      
      if (pricesMatch || attempts >= maxAttempts) {
        stopPolling();
        if (pricesMatch) {
          console.log('Price Sync: Prices synced successfully after', attempts, 'attempts');
        } else {
          console.warn('Price Sync: Stopped polling after', attempts, 'attempts (prices may not match)');
        }
      }
    }, 200); // Check every 200ms
    
    // Safety timeout - stop polling after 15 seconds
    pollingTimeout = setTimeout(function() {
      stopPolling();
      console.warn('Price Sync: Polling timeout reached');
    }, 15000);
  }
  
  function stopPolling() {
    if (pollingInterval) {
      clearInterval(pollingInterval);
      pollingInterval = null;
    }
    if (pollingTimeout) {
      clearTimeout(pollingTimeout);
      pollingTimeout = null;
    }
    isPolling = false;
  }
  
  // Listen for section updates (triggered when variant changes)
  document.addEventListener('theme:section:update', function(e) {
    console.log('Price Sync: theme:section:update event fired');
    // Wait a bit for Section API to finish replacing HTML, then start polling
    setTimeout(startPolling, 100);
  });
  
  // Also listen for section load events
  document.addEventListener('theme:section:load', function(e) {
    console.log('Price Sync: theme:section:load event fired');
    setTimeout(startPolling, 100);
  });
  
  // Use MutationObserver to watch for DOM changes in the product section
  var observer = new MutationObserver(function(mutations) {
    var shouldSync = false;
    
    mutations.forEach(function(mutation) {
      // Check if price elements were added, removed, or modified
      if (mutation.type === 'childList') {
        // Check if any added/removed nodes are price-related
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            if (node.querySelector && (
                node.querySelector('[data-product-price]') ||
                node.classList && node.classList.contains('product__price-block')
            )) {
              shouldSync = true;
            }
          }
        });
        mutation.removedNodes.forEach(function(node) {
          if (node.nodeType === 1 && node.querySelector && node.querySelector('[data-product-price]')) {
            shouldSync = true;
          }
        });
      } else if (mutation.type === 'characterData') {
        // Text content changed - might be a price update
        var target = mutation.target;
        if (target.parentElement && target.parentElement.hasAttribute('data-product-price')) {
          shouldSync = true;
        }
      }
    });
    
    if (shouldSync) {
      startPolling();
    }
  });
  
  // Track which inputs we've already watched to avoid duplicates
  var watchedInputs = new WeakSet();
  
  // Also watch for variant input changes directly
  function watchVariantInputs() {
    var variantInputs = document.querySelectorAll('input[name^="options["], input[type="radio"][name^="options["]');
    variantInputs.forEach(function(input) {
      // Only add listener if we haven't already
      if (!watchedInputs.has(input)) {
        watchedInputs.add(input);
        input.addEventListener('change', function() {
          console.log('Price Sync: Variant input changed');
          // Start polling after a short delay to let Section API start
          setTimeout(startPolling, 50);
        });
      }
    });
  }
  
  // Start observing when DOM is ready
  function startObserving() {
    var productSection = document.querySelector('[data-section-type="product"]') ||
                         document.querySelector('.product-section') ||
                         document.querySelector('.section-product');
    
    if (productSection) {
      // Observe the entire product section
      observer.observe(productSection, {
        childList: true,
        subtree: true,
        characterData: true
      });
      
      // Also specifically watch the mobile price container
      var mobileContainer = productSection.querySelector('.medium-up--hide');
      if (mobileContainer) {
        observer.observe(mobileContainer, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }
      
      // Watch variant inputs
      watchVariantInputs();
      
      // Re-watch inputs if section gets updated (inputs might be replaced)
      var sectionObserver = new MutationObserver(function() {
        watchVariantInputs();
      });
      sectionObserver.observe(productSection, {
        childList: true,
        subtree: true
      });
      
      console.log('Price Sync: MutationObserver started');
      
      // Initial sync on page load
      setTimeout(function() {
        syncPrices();
      }, 500);
    } else {
      // Retry if product section not found yet
      setTimeout(startObserving, 500);
    }
  }
  
  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      startObserving();
    });
  } else {
    startObserving();
  }
})();